import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {PlayerMarketData} from "../../@types/response";

export const getPlayerMarkets = (state: ReducerFromState<CommonReducer>): PlayerMarketData => state.common.playerMarkets;